/**
 * @file variant.variantReferenceFind.saga.js
 * @description finds gDot, chromosome, geneSymbol for cDot+transcript
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jun 29, 2024 16:57
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import store from 'src/store';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { arrayExists, objectExists, objectHas, stringExists } from 'src/@common/utilities';

import {
    VARIANT_REFERENCE_FIND_REQUEST,
    variantReferenceFindSuccess,
    variantReferenceFindFailure,
} from 'src/store/actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/reference/find';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            cDot: payload.cDot,
            genomeBuild: payload.genomeBuild,
            transcript: payload.transcript,
            annotationId: payload.annotationId,
            variantId: payload.variantId
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.staticInfoMessage.options)
            );
        }

        if (objectExists(resp.payload)) {

            if (objectHas(resp.payload, 'variantReferenceObj.messages') &&
                arrayExists(resp.payload.variantReferenceObj.messages)) {

                resp.payload.variantReferenceObj.messages.forEach((item) => {

                    // note: had to use store.dispatch here because
                    // yield caused a reserved-word syntax error
                    store.dispatch(enqueueMessage(
                        item,
                        standardMessages.staticInfoMessage.options)
                    );

                });

            }
        }

        yield put(variantReferenceFindSuccess(resp.payload));

    } catch (error) {
        yield put(variantReferenceFindFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(VARIANT_REFERENCE_FIND_REQUEST, createRequestSaga);
}
